import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RZPay, ajaxerrmsg } from '../../actions/http';
import { orderPayOnline, listAction, clearPayOnline, bookOnline, clearOrder, addToast } from '../../actions';
import {orders_api} from "../../actions/http"
import ButtonLoader from '../btnloader';

class OrderDue extends Component {

    pay = () => {
        // this.click = true;
        // this.props.orderPayOnline(this.props.id);
        this.props.addToast("Online payment not yet availbale");
    }

    componentDidUpdate(prevProps){
        let { payment_online, user, listAction, bookOnline, createOrder} = this.props;
        if(payment_online.data && !prevProps.payment_online.data){
            RZPay(payment_online.data, user, bookOnline);
        }
        if(createOrder.data && !prevProps.createOrder.data){
            listAction("LOAD", "ORDERLIST_UPCOMING", `${orders_api}?is_completed=false`);
            listAction("LOAD", "ORDERLIST_COMPLETED", `${orders_api}?is_completed=true`);
        }
        this.checkError(createOrder, prevProps.createOrder);
        this.checkError(payment_online, prevProps.payment_online);
    }

    checkError(current, previous){
        if(current["error"] && !previous["error"]){
            this.props.addToast(ajaxerrmsg(current["error"]), false);
        }
    }

    render() {
        let {payment_online, createOrder} = this.props;
        return (
            <button 
                className="btn paidlabel unpaid"
                disabled={false}
                onClick={this.pay}
            >
                {(payment_online.fetching || createOrder.fetching) && this.click ?
                    <ButtonLoader /> : 'Due'
                }
            </button>
        )
    }

    componentWillUnmount(){
        this.props.clearPayOnline();
        this.props.clearOrder();
    }
}

const mapStateToProps = ({loginReducer, createOrder, order_online_pay}) => {
    return {
        createOrder, 
        payment_online: order_online_pay,
        user: loginReducer.data
    }
}

const mapDispatchToProps = {
    orderPayOnline, listAction, clearPayOnline, bookOnline, clearOrder, addToast
}


const OrderDueBtn = connect(mapStateToProps, mapDispatchToProps)(OrderDue)

export default OrderDueBtn
